<div class="umbraco-empty-block__container">
    <h4>Media enquiries</h4>
    <p class="umbraco-empty-block__container__name">{{ name }}</p>
    <a
        class="umbraco-empty-block__container__telephone"
        nw-link
        [href]="'tel:' + telephone"
        >{{ telephone }}</a
    >
    <a class="umbraco-empty-block__container__email" nw-link [href]="'mailto:' + email">{{
        email
    }}</a>
</div>
